import { lazy } from 'react';

import { ACTIVITY_PATHS } from 'common/activities/utils/constants';
import { SiteActivityType } from 'common/activities/utils/types';
import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { preloadLazyComponent } from 'common/utils/useLoading';
import { SUPPORT_ROLES } from 'common/utils/user';

export const PATIENT_CHART_PATH = '/chart/:patientId/:patientDetails?';

export const routes = [
    {
        component: preloadLazyComponent(() => import('module/patient/create/CreatePatientPage')),
        permissions: ['Patient_Create'],
        path: '/patient/basicdetails',
        role: [RoleVariantEnum.SiteCoordinator, RoleVariantEnum.SiteInvestigator],
        studySiteRequired: true,
    },
    {
        component: preloadLazyComponent(() => import('module/patient/create/CreatePatientVisitSchedulePage')),
        permissions: ['Patient_Create'],
        path: '/patient/:patientId/:studyId/visitschedule',
        role: [RoleVariantEnum.SiteCoordinator, RoleVariantEnum.SiteInvestigator],
        studySiteRequired: true,
    },
    {
        component: preloadLazyComponent(() => import('./patientchart/PatientChartPage')),
        permissions: ['Patient_Create'],
        path: '/chart/:patientId',
        role: [
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
        ],
        studySiteRequired: true,
    },
    {
        component: preloadLazyComponent(() => import('./patientchart/PatientChartPage')),
        permissions: ['Patient_Create'],
        path: PATIENT_CHART_PATH,
        role: [
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.ClinicalTrialLead,
        ],
        studySiteRequired: true,
        canBeLandingPage: true,
    },
    {
        component: lazy(() => import('module/patient/econsent/econsent.page')),
        // @todo: Check permissions and roles for this page
        permissions: [],
        role: [],
        path: '/chart/:patientId/econsent/:studyPK/:patientSK/:patientName/:ICFSubRowHeader',
    },
    {
        component: lazy(() => import('module/patient/activity/HomeActivityPage')),
        permissions: ['StudyActivityInstance_Create', 'StudyActivityInstance_Edit'],
        path: ACTIVITY_PATHS[SiteActivityType.HOME_TRANSCRIPTION],
        role: [RoleVariantEnum.SiteCoordinator, RoleVariantEnum.SiteInvestigator, RoleVariantEnum.DataChangeSupport],
        studySiteRequired: true,
    },
    {
        component: lazy(() => import('module/patient/activity/HomeActivityPage')),
        permissions: ['StudyActivityInstance_Create', 'StudyActivityInstance_Edit'],
        path: ACTIVITY_PATHS[SiteActivityType.DCR],
        role: [RoleVariantEnum.DataChangeSupport],
        studySiteRequired: true,
    },
    {
        component: lazy(() => import('module/patient/activity/HomeActivityPage')),
        permissions: ['StudyActivityInstance_Create', 'StudyActivityInstance_Edit'],
        path: ACTIVITY_PATHS[SiteActivityType.HOME_VIEW],
        role: [
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.ClinicalTrialLead,
            ...SUPPORT_ROLES,
        ],
        studySiteRequired: true,
    },
    {
        component: lazy(() => import('module/patient/activity/SiteActivityPage')),
        permissions: [
            'Study_Read',
            'Study_Create',
            'Study_Edit',
            'Study_Delete',
            'StudyActivityInstance_Create',
            'StudyActivityInstance_Edit',
        ],
        path: ACTIVITY_PATHS[SiteActivityType.SITE],
        role: [
            BaseRoles.UserId,
            RoleVariantEnum.SiteCoordinator,
            RoleVariantEnum.SiteInvestigator,
            RoleVariantEnum.Monitor,
            RoleVariantEnum.DataManager,
            RoleVariantEnum.Inspector,
            RoleVariantEnum.ProductSupport,
            RoleVariantEnum.DataChangeSupport,
            RoleVariantEnum.ClinicalTrialLead,
        ],
        studySiteRequired: true,
    },
    {
        component: preloadLazyComponent(() => import('./patientchart/InaccessiblePage')),
        permissions: [],
        role: [],
        path: '/patientAccessDenied',
    },
];
